const PENDING_STATUS = 0
const AWAITING_REVIEW_STATUS = 1
const APPROVED_STATUS = 2
const DISAPPROVED_STATUS = 3
const RISK_ASSUMED_STATUS = 4
const INACTIVE_STATUS = 5
const SOFT_DELETE_STATUS = 6

const PENDING_STATUS_LABEL = 'pending'
const AWAITING_REVIEW_STATUS_LABEL = 'awaiting_review'
const APPROVED_STATUS_LABEL = 'approved'
const DISAPPROVED_STATUS_LABEL = 'disapproved'
const RISK_ASSUMED_STATUS_LABEL = 'risk_assumed'
const INACTIVE_STATUS_LABEL = 'inactive'
const SOFT_DELETE_STATUS_LABEL = 'soft_delete'

const STATUSES = {
  [PENDING_STATUS_LABEL]: 'PENDENTE',
  [AWAITING_REVIEW_STATUS_LABEL]: 'AGUARDANDO REVISÃO',
  [APPROVED_STATUS_LABEL]: 'APROVADO',
  [DISAPPROVED_STATUS_LABEL]: 'REPROVADO',
  [RISK_ASSUMED_STATUS_LABEL]: 'RISCO ASSUMIDO',
  [INACTIVE_STATUS_LABEL]: 'INATIVO',
  [SOFT_DELETE_STATUS_LABEL]: 'EXCLUÍDO',
}

const TABS = [
  { value: null, label: 'Todos' },
  { value: PENDING_STATUS, label: 'Pendente' },
  { value: AWAITING_REVIEW_STATUS, label: 'Aguardando Revisão' },
  { value: APPROVED_STATUS, label: 'Aprovados' },
  { value: DISAPPROVED_STATUS, label: 'Reprovados' },
  { value: RISK_ASSUMED_STATUS, label: 'Risco Assumido' },
  { value: INACTIVE_STATUS, label: 'Inativos' },
]

// Tabs por label de status, para as listagens que filtram pelo status textual
// (portal de convidados); o app filtra pelo enum das TABS acima.
const STATUS_LABEL_TABS = [
  { value: null, label: 'Todos' },
  { value: PENDING_STATUS_LABEL, label: 'Pendente' },
  { value: AWAITING_REVIEW_STATUS_LABEL, label: 'Aguardando Revisão' },
  { value: APPROVED_STATUS_LABEL, label: 'Aprovados' },
  { value: DISAPPROVED_STATUS_LABEL, label: 'Reprovados' },
  { value: RISK_ASSUMED_STATUS_LABEL, label: 'Risco Assumido' },
  { value: INACTIVE_STATUS_LABEL, label: 'Inativos' },
]

// Status em que o projeto já passou pelo revisor e exibe o parecer.
const REVIEWED_STATUSES = [
  APPROVED_STATUS_LABEL,
  DISAPPROVED_STATUS_LABEL,
  RISK_ASSUMED_STATUS_LABEL,
]

// Questões sem alternativas cadastradas respondem por esta escala fixa.
const SIMPLE_ANSWERS = ['Sim', 'Parcial', 'Não']

// Limites dos campos de texto, espelhando as validações da API.
const NAME_MAX_LENGTH = 255
const DESCRIPTION_MAX_LENGTH = 2000
const JUSTIFY_MAX_LENGTH = 1000

const REOPEN_ACTION_BUTTON_STATUS = 'reopen'
const ACTIVATE_ACTION_BUTTON_STATUS = 'activate'

const CONFIRMATION_CHANGE_STATUS_TEXTS = {
  [ACTIVATE_ACTION_BUTTON_STATUS]:
    "Deseja reativar este projeto de Privacy by Design? Ao confirmar, o status retornará para 'Pendente'.",
  [AWAITING_REVIEW_STATUS_LABEL]:
    'Deseja enviar este projeto para revisão? Certifique-se de que todas as alterações foram salvas.',
  [INACTIVE_STATUS_LABEL]: 'Deseja inativar este projeto de Privacy by Design?',
  [REOPEN_ACTION_BUTTON_STATUS]:
    "Deseja reabrir este projeto de Privacy by Design? Ao confirmar, o status retornará para 'Pendente'.",
  [SOFT_DELETE_STATUS_LABEL]:
    'Deseja excluir este projeto de Privacy by Design? Ao confirmar, não será mais possível recuperá-lo.',
}

const PRIVACY_BY_DESIGN_DRIVER_STEP_0 = 'privacy-by-design-driver-step-0'
const PRIVACY_BY_DESIGN_DRIVER_STEP_1 = 'privacy-by-design-driver-step-1'
const PRIVACY_BY_DESIGN_DRIVER_STEP_LINK = 'privacy-by-design-driver-step-link'
const PRIVACY_BY_DESIGN_DRIVER_STEP_2 = 'privacy-by-design-driver-step-2'

const PRIVACY_BY_DESIGN_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + PRIVACY_BY_DESIGN_DRIVER_STEP_0,
    popover: {
      description:
        'O módulo de Privacy by Design permite mapear e avaliar o uso de dados pessoais antes do início de qualquer atividade, garantindo que apenas informações necessárias sejam coletadas. Ele é o ponto inicial para estruturar processos com foco em privacidade e conformidade desde a concepção.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_DRIVER_STEP_1,
    popover: {
      description:
        'Clique aqui para iniciar um novo projeto de Privacy by Design.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_DRIVER_STEP_LINK,
    popover: {
      description:
        'Clique aqui para configurar o link externo do portal de visitantes. Você pode ativar o portal, definir a validade do token e gerenciar os e-mails com acesso.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_DRIVER_STEP_2,
    popover: {
      description:
        'Nesta tabela, todos os seus projetos estão listados. É possível filtrá-los por status utilizando a barra superior ou aplicar outros filtros pelo botão “Filtro”, no canto direito da tela.',
    },
  },
]

const ONLY_LIST_PRIVACY_BY_DESIGN_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + PRIVACY_BY_DESIGN_DRIVER_STEP_0,
    popover: {
      description:
        'O módulo de Privacy by Design permite mapear e avaliar o uso de dados pessoais antes do início de qualquer atividade, garantindo que apenas informações necessárias sejam coletadas. Ele é o ponto inicial para estruturar processos com foco em privacidade e conformidade desde a concepção.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_DRIVER_STEP_2,
    popover: {
      description:
        'Nesta tabela, todos os seus projetos estão listados. É possível filtrá-los por status utilizando a barra superior ou aplicar outros filtros pelo botão “Filtro”, no canto direito da tela.',
    },
  },
]

const PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_0 =
  'privacy-by-design-form-driver-step-0'
const PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1 =
  'privacy-by-design-form-driver-step-1'
const PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_2 =
  'privacy-by-design-form-driver-step-2'
const PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_3 =
  'privacy-by-design-form-driver-step-3'
// As abas de status das questões, destacadas em um passo separado da lista.
const PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_TABS =
  'privacy-by-design-form-driver-step-tabs'

const NEW_PRIVACY_BY_DESIGN_FORM_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_0,
    popover: {
      description:
        'Esta tela é destinada ao desenvolvimento do projeto sob a ótica de Privacy by Design e também indica quais tópicos precisam ser aprimorados para que o projeto esteja em conformidade com a LGPD.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1,
    popover: {
      description:
        'Preencha o nome, a finalidade, o departamento e o responsável pelo projeto. O questionário escolhido define as questões que serão respondidas.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_2,
    popover: {
      description:
        'Ao criar o projeto, ele não será enviado para revisão automaticamente. As questões são respondidas na tela de edição e, depois disso, você envia o projeto para a análise do DPO.',
    },
  },
]

const EDIT_PRIVACY_BY_DESIGN_FORM_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_0,
    popover: {
      description:
        'Esta tela é destinada ao desenvolvimento do projeto sob a ótica de Privacy by Design e também indica quais tópicos precisam ser aprimorados para que o projeto esteja em conformidade com a LGPD.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1,
    popover: {
      description:
        'Aqui ficam as informações gerais do projeto. Altere o que for necessário e clique em Salvar.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_TABS,
    popover: {
      description:
        'Use as abas para ver todas as questões, apenas as pendentes ou apenas as já respondidas.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_2,
    popover: {
      description:
        'Responda as questões uma a uma: marque a alternativa e clique em Salvar. Algumas alternativas exigem justificativa e evidência anexada. Para alterar uma resposta já salva, clique em Reabrir.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_3,
    popover: {
      description:
        'Com todas as questões respondidas, envie o projeto para revisão. Enquanto o DPO não aprovar ou reprovar, as respostas não podem ser alteradas.',
    },
  },
]

const privacyByDesign = {
  ACTIVATE_ACTION_BUTTON_STATUS,
  APPROVED_STATUS_LABEL,
  APPROVED_STATUS,
  AWAITING_REVIEW_STATUS_LABEL,
  AWAITING_REVIEW_STATUS,
  CONFIRMATION_CHANGE_STATUS_TEXTS,
  DISAPPROVED_STATUS_LABEL,
  DISAPPROVED_STATUS,
  EDIT_PRIVACY_BY_DESIGN_FORM_DRIVER_STEPS_OBJECT,
  INACTIVE_STATUS_LABEL,
  INACTIVE_STATUS,
  NEW_PRIVACY_BY_DESIGN_FORM_DRIVER_STEPS_OBJECT,
  ONLY_LIST_PRIVACY_BY_DESIGN_DRIVER_STEPS_OBJECT,
  PENDING_STATUS_LABEL,
  PENDING_STATUS,
  PRIVACY_BY_DESIGN_DRIVER_STEP_0,
  PRIVACY_BY_DESIGN_DRIVER_STEP_1,
  PRIVACY_BY_DESIGN_DRIVER_STEP_LINK,
  PRIVACY_BY_DESIGN_DRIVER_STEP_2,
  PRIVACY_BY_DESIGN_DRIVER_STEPS_OBJECT,
  PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_0,
  PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1,
  PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_2,
  PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_3,
  PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_TABS,
  DESCRIPTION_MAX_LENGTH,
  JUSTIFY_MAX_LENGTH,
  NAME_MAX_LENGTH,
  REOPEN_ACTION_BUTTON_STATUS,
  REVIEWED_STATUSES,
  RISK_ASSUMED_STATUS_LABEL,
  RISK_ASSUMED_STATUS,
  SIMPLE_ANSWERS,
  SOFT_DELETE_STATUS_LABEL,
  SOFT_DELETE_STATUS,
  STATUS_LABEL_TABS,
  STATUSES,
  TABS,
}

export default privacyByDesign
